import React from 'react'
export default function LoadingIndicator(props) {
    const type = props.type ? props.type : "element"
    return (
        <span className={`loading-indicator ${type}`}>
            <span className='sr-text'>Loading</span>
            <span className="loading-indicator__spinner"></span>
        </span>
    )
}